import { PhoneOutlined } from "@ant-design/icons";
import { Space, Tooltip } from "antd";
import type { TFunction } from "i18next";

/**
 * A speaker's name, with the note that they want to be phoned during the week
 * of their assignment (Speaker#contact_me). The old application drew a small
 * grey icon behind the name for it, on every grid that named a speaker; this is
 * the same thing, and it lives here because three screens show it.
 */
export function SpeakerName({
  name,
  contactMe,
  hint,
}: {
  name: string | null | undefined;
  contactMe: boolean | undefined;
  /** t("speaker.contact_me") — passed in so this file stays free of i18n wiring. */
  hint: string;
}) {
  if (!name) return null;
  if (!contactMe) return <>{name}</>;

  return (
    <Space size={4}>
      <span>{name}</span>
      <Tooltip title={hint}>
        <PhoneOutlined style={{ color: "#8d8d8d" }} />
      </Tooltip>
    </Space>
  );
}

/** The same for a file, where an icon says nothing. */
export function speakerNameText(
  name: string | null | undefined,
  contactMe: boolean | undefined,
  t: TFunction,
): string | null {
  if (!name) return null;
  return contactMe ? `${name} (${t("speaker.contact_me")})` : name;
}
